import { render } from "./FullPageModal.vue?vue&type=template&id=2d384b1d"
import script from "./FullPageModal.vue?vue&type=script&lang=js"
export * from "./FullPageModal.vue?vue&type=script&lang=js"

import "./FullPageModal.vue?vue&type=style&index=0&id=2d384b1d&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__